import React from "react";
import LastBallsCon from "./LastBallsCon/LastBallsCon";
import BigBall from "./BigBall/BigBall";
import "./LotteryDrumSection.css"


export default function LotteryDrumSection({ flexValue = 1 }) {
  return (
    <div className="lottery-drum-container" style={{ flex: flexValue }}>
      <div className="video-con">
        <video className="video" src="./assets/lottery_drum.mp4" autoPlay muted loop ></video>
        <BigBall />
      </div>
      <LastBallsCon />
    </div>
  )
}